import { getAsync, postAsync } from "./http-client";

const CardApi = {
  get: async (shopIdx) => {
    return await getAsync(`/ceo/cardManage/${shopIdx}`);
  },
  getChanged: async (shopIdx) => {
    return await getAsync(`/ceo/cardManageChanged/${shopIdx}`);
  },
  edit: async (data) => {
    return await postAsync(`/ceo/cardManage`, data);
  },
};
export default CardApi;
